module.exports = __webpack_public_path__ + "img/Retail Shopfitting & Display Summit.057daf7b.png";